export const getDisplayCategory = status => {
  return !status || status !== 'not_found' ? 'smartLink' : 'link';
};